import { Tooltip } from '@progress/kendo-react-tooltip';
import { isEmpty } from 'lodash';
import BuyerInfoModal from 'src/components/BuyerInfoModal';
import Accordion from 'src/components/design-system/Accordion';
import useReceiptDetails from 'src/hooks/useReceiptDetails';
import DeliveryCompany from './DeliveryCompany';
import DeliveryDate from './DeliveryDate';
import DeliveryDriver from './DeliveryDriver';
import DocumentDate from './DocumentDate';
import PoNumber from './PoNumber';
import ReceiptNote from './ReceiptNote';
import ReceiptNumber from './ReceiptNumber';
import ReceiptStatus from './ReceiptStatus';
import SupplierInfoModal from './SupplierInfoModal';

const ReceiptInfo = () => {
  const { receiptData } = useReceiptDetails();

  return (
    <>
      <Accordion
        title={`Details for Receipt #${receiptData?.receivingReceiptId || ''}`}
        defaultExpanded
        expandAlways
      >
        <Tooltip anchorElement="target" position="bottom" parentTitle>
          {!isEmpty(receiptData) && (
            <div className="p-1">
              <div className="grid grid-cols-2 grid-rows-5 md:grid-cols-2 md:grid-rows-5 lg:grid-cols-5 lg:grid-rows-2 xl:grid-cols-6 xl:grid-rows-2">
                <ReceiptNumber />
                <PoNumber />
                <SupplierInfoModal supplierInfo={receiptData?.supplierDetails} />
                <BuyerInfoModal buyerInfo={receiptData?.buyerDetails} />
                <DocumentDate />
                <DeliveryDate />
                <ReceiptStatus />
                <DeliveryDriver />
                <DeliveryCompany />
                <ReceiptNote />
              </div>
            </div>
          )}
        </Tooltip>
      </Accordion>
    </>
  );
};

export default ReceiptInfo;
